export enum LocalStorageNameKeys {
  FAVORITES = 'favorites'
}
